import { ApiGender } from '../api-types/gender.api';
import { Gender } from '../app-types/gender.app';

/**
 * Transforms an ApiGender object to an app-specific Gender object.
 * @param input ApiGender
 * @description Transforms an ApiGender object to an app-specific Gender object.
 * @returns Gender
 */
export const transformApiGenderToAppGender = (input: ApiGender) => {
	const output: Gender = {
		id: input.id,
		salutationSuggestion: input.salutationSuggestion,
		salutation: input.salutation,
		initials: input.initials,
	};
	return output;
};

/**
 * Transforms an array of ApiGender objects to an array of app-specific
 * Gender objects.
 * @param input Array of ApiGender objects
 * @description Transforms an array of ApiGender objects to an array of app-specific Gender objects.
 * @returns Array of app-specific Gender objects
 */
export const transformApiGendersToAppGenders = (input: ApiGender[]) => {
	const output: Gender[] = input.map(transformApiGenderToAppGender);
	return output;
};

/**
 * Transforms an app-specific Gender object to an ApiGender object.
 * @param input Gender
 * @returns ApiGender
 */
export const transformAppGenderToApiGender = (input: Gender) => {
	const output: ApiGender = {
		id: input.id,
		salutationSuggestion: input.salutationSuggestion,
		salutation: input.salutation,
		initials: input.initials,
	};
	return output;
};
